import { Component, Prop, h, Host, Element } from "@stencil/core";
import { getFirstNestedChild } from "../../utils/dom-helper";

/**
 * @slot circle-image - Holds a single eon-ui-image element
 */

@Component({
  tag: "eon-ui-circle",
  styleUrl: "circle.scss",
  assetsDirs: ["asset-circle"],
  shadow: true
})
export class Circle {
  @Element() hostElement: HTMLEonUiCircleElement;
  private imageElement: HTMLEonUiImageElement;
  /**
   * Defines the image source that is used by the image and shown in the
   * center of the circle. If the src value is not set,
   * the inner circle appears in the color white.
   */
  @Prop() src: string = "";

  /**
   * Defines the value of the alt attribute for the image passed to "src".
   */
  @Prop() alt: string;

  /**
   * Defines the value of the title attribute for the image passed to "title".
   */
  @Prop() imageTitle: string;

  /**
   * Defines the horizontal image position.
   * @example "left", "right",
   * @default "right"
   */
  @Prop() imagePosition: "left" | "right" = "right";

  /**
   * Defines the color of the outer circle.
   * @default "#7dcdf4"
   */
  @Prop() colorOuterCircle: string = "#7dcdf4";

  /**
   * Defines the color of the middle circle.
   * @default "#019ca5"
   */
  @Prop() colorMiddleCircle: string = "#019ca5";

  componentWillLoad() {
    this.imageElement = getFirstNestedChild(this.hostElement, "eon-ui-image");
    if (this.imageElement) {
      this.imageElement.setAttribute("use-as-background", "true");
    }
  }

  render() {
    return (
      <Host>
        <div class="container">
          <div
            class="outer-circle"
            style={{ justifyContent: this.imagePosition, backgroundColor: this.colorOuterCircle }}
          >
            <div
              class="middle-circle"
              style={{ justifyContent: this.imagePosition, backgroundColor: this.colorMiddleCircle }}
            >
              <div class="inner-circle">
                <slot name="circle-image"></slot>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
